package meineglasfaser.api.routes

import io.ktor.resources.*
import kotlinx.serialization.Serializable
import meineglasfaser.api.InvoiceDeliveryMode

@Resource("/admin")
class AdminRoutes {
    @Resource("/account")
    class Account(val parent: AdminRoutes = AdminRoutes()) {
        @Resource("/base-info")
        class BaseInfo(val parent: Account = Account())
    }

    @Resource("/customers")
    class Customers(val parent: AdminRoutes = AdminRoutes()) {
        @Resource("/{nid}")
        class ByNid(val nid: Int, val parent: Customers = Customers()) {
            @Resource("/update-phone-numbers")
            class UpdatePhoneNumbers(val parent: ByNid) {
                @Serializable
                data class RequestBody(
                    val telFixedLine: String,
                    val telMobile: String,
                )
            }

            @Resource("/update-invoicing-address")
            class UpdateInvoicingAddress(val parent: ByNid)

            @Resource("/update-invoicing-data")
            class UpdateInvoicingData(val parent: ByNid) {
                @Serializable
                data class RequestBody(
                    val invoicingEmail: String,
                    val invoicingDeliveryMode: InvoiceDeliveryMode,
                    val invoicingAccountHolder: String,
                    val invoicingIBAN: String,
                )
            }
        }
    }

    @Resource("/network-categories")
    class NetworkCategories(val parent: AdminRoutes = AdminRoutes()) {
        @Resource("/{id}")
        class ById(val id: String, val parent: NetworkCategories = NetworkCategories())
    }

    @Resource("/networks")
    class Networks(val parent: AdminRoutes = AdminRoutes()) {
        @Resource("/new")
        class New(val parent: Networks = Networks())

        @Resource("/{id}")
        class ById(val id: String, val parent: Networks = Networks())
    }

    @Resource("/addon-groups")
    class AddonGroups(val parent: AdminRoutes = AdminRoutes()) {
        @Resource("/new")
        class New(val parent: AddonGroups = AddonGroups())

        @Resource("/{id}")
        class ById(val id: String, val parent: AddonGroups = AddonGroups())
    }

    @Resource("/products")
    class Products(val parent: AdminRoutes = AdminRoutes()) {
        @Resource("/new")
        class New(val parent: Products = Products())

        @Resource("/{id}")
        class ById(val id: String, val parent: Products = Products())
    }

    @Resource("/orders")
    class Orders(val parent: AdminRoutes = AdminRoutes()) {
        @Resource("/{nid}")
        class ByNid(val nid: Int, val parent: Orders = Orders())
    }

    @Resource("/survey")
    class Survey(val parent: AdminRoutes = AdminRoutes()) {
        @Resource("/dashboard")
        class Dashboard(val parent: Survey = Survey())

        @Resource("/all-entries")
        class AllEntries(val parent: Survey = Survey())

        @Resource("/entries")
        class Entries(val surveyId: String, val parent: Survey = Survey())

        @Resource("/update-entry/{entryId}")
        class UpdateEntry(val entryId: String, val parent: Survey = Survey())

        @Resource("/create")
        class Create(val parent: Survey = Survey()) {
            @Serializable
            data class RequestBody(
                val title: String,
                val households: Int,
            )
        }

        @Resource("/{id}")
        class Id(val id: String, val parent: Survey = Survey())
    }

    @Resource("/workflows")
    class Workflows(val parent: AdminRoutes = AdminRoutes())
}
